import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import LoadScript from "react-load-script";
import $ from 'jquery';
import { vantivUrl } from '../../util/apiUtil';
import { Form, Field, withFormik } from 'formik';
import * as yup from 'yup'; // Form Debugger

import { Debug } from "./Debug";
import { Row, Col, FormGroup } from 'react-bootstrap'; // Global Elements

import { FormInput } from '../forms/elements';
import { StateBootstrapButton as StateButton } from "../forms/elements/Button";
import { payPageId, merchantId } from '../../util/apiUtil';
import { getSessionStorageKey } from '../../util/sessionStorage';

if (typeof window !== 'undefined') {
  window.jQuery = $;
  window.$ = $;
  global.jQuery = $;
}

var formikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {};
  },
  validationSchema: yup.object().shape({}),
  handleSubmit: function handleSubmit(values, _ref) {
    var setSubmitting = _ref.setSubmitting;
    setSubmitting(false); // setTimeout(() => {
    //   setSubmitting(false);
    // }, 1000);
  },
  displayName: "CreditCardInfo" // helps with React DevTools

});
var initialValues = {};

var CreditCardEprotect = function CreditCardEprotect(props) {
  var values = props.values,
      AUTHSTATE = props.AUTHSTATE,
      setFieldValue = props.setFieldValue,
      check = props.check,
      code1 = props.code1,
      tipAmount = props.tipAmount,
      orderId = props.orderId,
      _props$showMobilePayW = props.showMobilePayWPError,
      showMobilePayWPError = _props$showMobilePayW === void 0 ? function (errorNumber) {
    console.log('showMobilePayWPError', errorNumber);
  } : _props$showMobilePayW,
      _props$setPayOrderPay = props.setPayOrderPayload,
      setPayOrderPayload = _props$setPayOrderPay === void 0 ? function (payload) {
    console.log('onPayloadRetrieved');
  } : _props$setPayOrderPay,
      _props$payForOrder = props.payForOrder,
      payForOrder = _props$payForOrder === void 0 ? function (payload) {
    console.log('payForOrder', payload);
  } : _props$payForOrder,
      id = props.id;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      saveCard = _useState2[0],
      setSaveCard = _useState2[1];

  Object.keys(values).forEach(function (key) {
    initialValues[key] = values[key];
  });
  var eProtectiframeClient;

  var handleWorldPayScript = function handleWorldPayScript() {
    // Handler when the DOM is fully loaded
    var configure = {
      "paypageId": "".concat(payPageId),
      "style": "CreditCardStyles3",
      //this should be the same name as the css file and changed to CreditCardStyles{next-version-number} for a new style change
      "height": "340px",
      "reportGroup": "pay_at_table",
      "timeout": "15000",
      "div": "eProtectiframe",
      "callback": eProtectiframeClientCallback,
      "showCvv": true,
      "months": {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
      },
      "numYears": 8,
      "tooltipText": "A CVV is the 3 digit code on the back of your Visa, MasterCard and Discover or a 4 digit code on the front of your American Express",
      "tabIndex": {
        "cvv": 1,
        "accountNumber": 2,
        "expMonth": 3,
        "expYear": 4
      },
      "placeholderText": {
        "cvv": "CVV",
        "accountNumber": "Card Number"
      },
      "maskAfterSuccessValue": "",
      "inputsEmptyCallback": inputsEmptyCallback,
      "enhancedUxFeatures": {
        "inlineFieldValidations": true,
        "noScrollBar": true // "enchancedUxVersion": 2,

      }
    };

    try {
      if (typeof window === "undefined") {
        return {};
      }

      var EprotectIframeClient = typeof window !== 'undefined' ? window.EprotectIframeClient : '';

      if (typeof EprotectIframeClient === 'undefined') {
        console.log("Couldn't download eprotect-iframe-client.min javascript");
      } else {
        eProtectiframeClient = new EprotectIframeClient(configure);
        eProtectiframeClient.autoAdjustHeight();
      }
    } catch (e) {
      console.error(e);
      return {};
    }

    document.getElementById("fCheckout").onsubmit = function () {
      //Dev NoteL Need add order id(orderId) and Merchant Txn ID(id).
      var message = {
        "id": merchantId,
        "orderId": orderId
      };
      console.log("getPaypageRegistrationId", message);
      startTime = new Date().getTime();
      eProtectiframeClient.getPaypageRegistrationId(message); //   eProtectiframeClient.getCheckoutId(message);

      return false;
    };
  };

  var inputsEmptyCallback = function inputsEmptyCallback() {};

  var startTime;

  var eProtectiframeClientCallback = function eProtectiframeClientCallback(response) {
    var cardTypes = {
      "VI": "VISA",
      "AX": "AMEX",
      "DI": "DISCOVER"
    };

    if (response.timeout) {
      var elapsedTime = new Date().getTime() - startTime;
      var timeoutMessage = 'Timed out after ' + elapsedTime + 'ms'; // handle timeout

      console.log(timeoutMessage);
    } else {
      if (response.response != 870) {
        console.error('World Pay Failed Submit', response);
        showMobilePayWPError(response.response);
        return false;
      } else {
        var isNotAValue = function isNotAValue(obj) {
          return obj === undefined || obj === null || obj === "" || obj === "null";
        };

        if (isNotAValue(response.expMonth) || isNotAValue(response.expMonth)) {
          showMobilePayWPError("noexpirationvalue");
          return false;
        }
      }

      values.firstSix = response.firstSix;
      values.lastFour = response.lastFour;
      values.type = response.type;
      values.expirymonth = response.expMonth;
      values.expiryyear = response.expYear;
      values.merchantTxnId = response.id;
      values.cardtype = response.type;
      values.wptokenizedpan = response.paypageRegistrationId;
      values.orderId = orderId;
      PayOrder(values, payForOrder, tipAmount);
    }
  };

  var formFields = {};

  var submitAfterEprotect = function submitAfterEprotect(response) {
    setEprotectResponseFields(response); //document.forms['fCheckout'].submit();
  };

  var onErrorAfterEprotect = function onErrorAfterEprotect(response) {
    setEprotectResponseFields(response);
  };

  var timeoutOnEprotect = function timeoutOnEprotect() {
    alert("We are experiencing technical difficulties. Please try again later");
  };

  var callEprotect = function callEprotect() {
    if (typeof new eProtect() != 'object') {
      alert("We are experiencing technical difficulties. Please try again later or call 555-555-1212 (API unavailable)");
    }

    var formFields = setEProtect();
    setEprotectResponseFields({
      "response": "",
      "message": ""
    });
    var eProtectRequest = {
      "paypageId": document.getElementById("request$paypageId").value,
      "reportGroup": document.getElementById("request$reportGroup").value,
      "orderId": document.getElementById("request$orderId").value,
      "id": document.getElementById("request$merchantTxnId").value,
      "checkoutIdMode": false,
      "applepay": "applepay",
      "url": "".concat(vantivUrl)
    };
    new eProtect().sendToEprotect(eProtectRequest, formFields, submitAfterEprotect, onErrorAfterEprotect, timeoutOnEprotect, 15000);
    return false;
  };

  var setEProtect = function setEProtect(props) {
    var formFields = {
      "accountNum": document.getElementById('ccNum'),
      "cvv": document.getElementById('cvvNum').value,
      "cvv2": document.getElementById('cvvNum'),
      "paypageRegistrationId": document.getElementById('response$paypageRegistrationId'),
      "bin": document.getElementById('response$bin')
    };
    return formFields;
  };

  var setEprotectResponseFields = function setEprotectResponseFields(response) {
    document.getElementById('response$code').value = response.response;
    document.getElementById('response$message').value = response.message;
    document.getElementById('response$responseTime').value = response.responseTime;
    document.getElementById('response$vantivTxnId').value = response.vantivTxnId;
    document.getElementById('response$checkoutId').value = response.checkoutId;
    document.getElementById('response$type').value = response.type;
    document.getElementById('response$accountRangeId').value = response.accountRangeId;
    document.getElementById('response$firstSix').value = response.firstSix;
    document.getElementById('response$lastFour').value = response.lastFour;
  };

  var PayOrder = function PayOrder(worldPayResponse, payForOrder, tipAmount) {
    var _mobilePayStorage$che, _mobilePayStorage$che2, _mobilePayStorage$che3;

    var mobilePayStorage = getSessionStorageKey('mobilepay');
    var payload = {
      Store: parseInt(code1),
      OrderCode: mobilePayStorage === null || mobilePayStorage === void 0 ? void 0 : (_mobilePayStorage$che = mobilePayStorage.check) === null || _mobilePayStorage$che === void 0 ? void 0 : _mobilePayStorage$che.OrderCode,
      OrderTotal: mobilePayStorage === null || mobilePayStorage === void 0 ? void 0 : (_mobilePayStorage$che2 = mobilePayStorage.check) === null || _mobilePayStorage$che2 === void 0 ? void 0 : _mobilePayStorage$che2.TotalToPay,
      Gratuity: tipAmount,
      Payments: [{
        TokenType: 'LVT',
        PaymentAmount: mobilePayStorage === null || mobilePayStorage === void 0 ? void 0 : (_mobilePayStorage$che3 = mobilePayStorage.check) === null || _mobilePayStorage$che3 === void 0 ? void 0 : _mobilePayStorage$che3.TotalToPay,
        AuthorizationToken: worldPayResponse.wptokenizedpan,
        CardType: worldPayResponse.cardtype,
        ExpiryDate: worldPayResponse.expirymonth + worldPayResponse.expiryyear,
        CardSuffix: worldPayResponse.lastFour,
        OrderSource: 'ecommerce'
      }] // CustomerEmail: 'jmcneal2@crackerbarrel.com'

    };
    payForOrder(payload);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LoadScript, {
    url: "".concat(vantivUrl, "/eProtect/js/eProtect-iframe-client3.min.js") // url={`${vantivUrl}/eProtect/js/eProtect-iframe-client4.min.js`}
    ,
    onLoad: handleWorldPayScript
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form, {
    id: "fCheckout",
    name: "fCheckout"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    id: "eProtectiframe"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null)), Boolean(AUTHSTATE) && /*#__PURE__*/React.createElement(CheckoutCheckbox, {
    className: "",
    checked: saveCard,
    onClick: function onClick() {
      setSaveCard(!saveCard);
      setFieldValue("savecarddetails", !saveCard);
    },
    label: "Save the card for future purchases"
  }))));
};

var CheckoutCheckbox = function CheckoutCheckbox(_ref2) {
  var _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {
    return "";
  } : _ref2$onClick,
      _ref2$checked = _ref2.checked,
      checked = _ref2$checked === void 0 ? false : _ref2$checked,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "" : _ref2$className,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? "" : _ref2$label;
  return /*#__PURE__*/React.createElement(FormGroup, {
    className: "cb-checkout__checkbox-group"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: className,
    checked: checked,
    onClick: onClick
  }), /*#__PURE__*/React.createElement("label", null, label));
};

export default formikEnhancer(CreditCardEprotect);